<template>
  <section id="contact">
    <div class="">
      <div>
        <customeTitle
          :smallTitle="i18n('navbar.contactUs')"
          :title="i18n('contactUs.desc')"
          :description="''"
        />
        <div class="contact-form">
          <Map
            lat="31.2401052"
            lng="29.9639989"
            :marker="[
              {
                lat: '31.2401052',
                lng: '29.9639989',
              },
            ]"
            productPage="false"
            divId="mainBranch"
          />
          <div class="form">
            <div
              class="section-title-wrapper text-center section-space--mb_50 wow move-up"
            >
              <h3 class="section-title text-white">
                {{ i18n("inq") }}
              </h3>
              <br />
              <h6 style="color: white" class="desc">
                {{ i18n("contact") }}
                <a
                  href="tel:+2002035837914"
                  class="hover-style-link hover-style-link--green"
                  >002035837914
                </a>
                {{ i18n("contact2") }}
              </h6>
            </div>
            <!-- newsletter form -->
            <div
              class="newsletter-form--one section-space--mb_20 text-center wow move-up"
            >
              <form action="#Home">
                <div class="col-12 shape c-div">
                  <input
                    type="text"
                    v-model="formData.name"
                    :placeholder="i18n('form.name')"
                    class="marginShape"
                    required
                  />
                  <input
                    type="email"
                    v-model="formData.email"
                    :placeholder="i18n('form.email')"
                    class="marginShape"
                    required
                  />
                </div>
                <div class="col-12 shape"></div>
                <div class="col-12 shape">
                  <input
                    type="text"
                    v-model="formData.subject"
                    :placeholder="i18n('form.subject')"
                    id="child"
                    class="col-lg-12 col-md-12 marginShape"
                    required
                  />
                </div>

                <div class="col-12 shape">
                  <textarea
                    cols="35"
                    v-model="formData.message"
                    rows="3"
                    :placeholder="i18n('form.message')"
                    class="col-lg-12 col-md-12 marginShape"
                    required
                  ></textarea>
                </div>

                <div class="ml-auto mr-auto">
                  <button class="c-button" @click.prevent="submitMethod()">
                    {{ i18n("submit") }}
                  </button>
                </div>
              </form>
            </div>

            <!-- newsletter text -->
            <h6 class="text-white text-center wow move-up desc">
              {{ i18n("next") }}
              <a
                href="https://mining.israagroup.com/"
                target="_blank"
                class="hover-style-link hover-style-link--green"
                >{{ i18n("mine") }}</a
              >
            </h6>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import Map from "../components/Map";
import customeTitle from "../components/customeTitle.vue";

export default {
  name: "newsletter",
  data() {
    return {
      formData: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
    };
  },
  methods: {
    i18n(key, args) {
      return this.$t(key, args);
    },
    ...mapActions({
      SubmitForm: "1/doSubmitContactForm",
    }),
    submitMethod() {
      if (
        !this.formData ||
        !this.formData.name ||
        !this.formData.email ||
        !this.formData.subject ||
        !this.formData.message
      ) {
        this.showNotif("fail");
        return;
      }
      this.SubmitForm(this.formData);
      this.formData.name = "";
      this.formData.email = "";
      this.formData.subject = "";
      this.formData.message = "";
      this.showNotif("success");
    },
    showNotif(value) {
      if (value == "success") {
        this.$notify({
          group: "notification",
          title: this.i18n("form.formSubmittedTitle"),
          text: this.i18n("form.formSubmittedSubtitle"),
          type: "success",
          position: "top right",
        });
      } else {
        this.$notify({
          group: "notification",
          title: this.i18n("form.formErrorTitle"),
          text: this.i18n("form.formErrorSubtitle"),
          type: "error",
          position: "top right",
        });
      }
    },
  },
  components: {
    Map,
    customeTitle,
  },
};
</script>

<style lang="scss" scoped>
.full-width {
  min-width: 565px !important;
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    min-width: 87% !important;
  }
  @media only screen and (max-width: 767px) {
    min-width: 85% !important;
  }
  @media only screen and (max-width: 320px) {
    min-width: 85%;
  }
  @media only screen and (max-width: 648px) {
    min-width: 85% !important;
  }
  @media only screen and (max-width: 575px) {
    min-width: 85% !important;
  }
}
::placeholder {
  color: #122a50 !important;
}
input {
  color: #122a50 !important;
  width: 100%;
}
textarea {
  color: #122a50 !important;
}
[dir="rtl"] .shape {
  padding-right: 0px !important;
}
[dir="rtl"] .marginShape {
  margin-right: 0px;
}
#contact {
  margin: 0px 0px 150px 0px !important;
  padding-top: 100px;
}
.contact-form {
  display: flex;
  margin-top: 100px;
  position: relative;
}
.form {
  position: absolute;
  z-index: 2;
  width: 430px;
  background: #122a50;
  top: -50%;
  transform: translate(15%, 13%);
  padding: 20px;
  border-radius: 15px;
}
textarea {
  line-height: 1.7;
}
.c-button {
  background: white;
  border: none;
  padding: 6px 30px;
  border-radius: 5px;
}
@media (width < 768px) {
  .contact-form {
    margin-top: 0px;
    line-height: 1;
  }
  .c-div {
    display: flex;
    width: 100%;
    gap: 10px;
  }
  .c-div input {
    min-width: unset !important;
    width: 100% !important;
  }
  .form {
    position: absolute;
    top: 24%;
    margin: 0px 15px;
    width: auto;
    transform: translate(0px, 0px) !important;
  }
  input {
    margin: 0px;
    margin-bottom: 10px;
  }
}

.desc {
  font-size: 15px !important;
}
[dir="rtl"] .form {
  transform: translate(-15%, 15%);
}

.newsletter-form--one input {
  height: 45px;
}
</style>
